export class TypeFuel {
  id?: number;
  slug: string;
  description: string;
  full_description?: string;
  id_1C: string;
}
